<template>
	<div class="colors">
		<a
			v-for="color in colors"
			class="color"
			:key="color.title"
			:class="{active: color.active}"
			:style="{backgroundColor: color.hex}"
			:title="color.title"
			@click="activate(color)"
		>
		</a>
	</div>
</template>

<script>
export default {
	props: {
		colors: {type: Array, required: true},
	},
	computed: {},
	methods: {
		activate(color) {
			this.colors.forEach((color) => (color.active = false));
			color.active = true;
		},
	},
};
</script>

<style lang="scss" scoped>
.colors {
	display: flex;
	justify-content: center;
	.color {
		$s: 18px;
		width: $s;
		height: $s;
		border-radius: 50%;
		margin: 0.25em;
		border: 1px solid $grey1;
		&.active {
			border-color: $black1;
		}
	}
}
</style>
